const Assert = {
    assertTrue: function (condition) {
        if (!condition) {
            throw new Error('Assert true failed');
        }
    },
};
export default Assert;

export const assertTrue = Assert.assertTrue;
